(function() {
    'use strict';

    angular
        .module('telestatApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('division-conversion-report', {
            parent: 'report',
            url: '/division-conversion-report?page&sort&search&searchType&startDate&endDate&insignificantFilter',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_MANAGER', 'ROLE_CHECKER'],
                pageTitle: 'telestatApp.divisionsConversionReport.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reports/division-conversion-report/division-conversion-report.html',
                    controller: 'DivisionConversionReportController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'divisionName,desc',
                    squash: true
                },
                searchType: {
                    value: 'lastmonth',
                    squash: true
                },
                startDate: null,
                endDate: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        searchType: $stateParams.searchType,
                        startDate: $stateParams.startDate,
                        endDate: $stateParams.endDate,
                        insignificantFilter: $stateParams.insignificantFilter
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reports');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('datefilter');
                    return $translate.refresh();
                }]
            }
        })
        .state('division-conversion-dynamic-report', {
            parent: 'report',
            url: '/division-conversion-dynamic-report?page&sort&search&searchType&startDate&endDate&insignificantFilter',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_DIRECTOR', 'ROLE_MANAGER', 'ROLE_CHECKER'],
                pageTitle: 'telestatApp.divisionsConversionReport.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/reports/division-conversion-report/division-conversion-dynamic-report.html',
                    controller: 'DivisionConversionDynamicReportController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'nameId,desc',
                    squash: true
                },
                searchType: {
                    value: 'lastmonth',
                    squash: true
                },
                startDate: null,
                endDate: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        searchType: $stateParams.searchType,
                        startDate: $stateParams.startDate,
                        endDate: $stateParams.endDate,
                        insignificantFilter: $stateParams.insignificantFilter
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reports');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('datefilter');
                    return $translate.refresh();
                }]
            }
        });
    }

})();
